import { render } from "./SystemTabArmazenamento.vue?vue&type=template&id=1f3cf35e&scoped=true&ts=true"
import script from "./SystemTabArmazenamento.vue?vue&type=script&lang=ts"
export * from "./SystemTabArmazenamento.vue?vue&type=script&lang=ts"

import "./SystemTabArmazenamento.vue?vue&type=style&index=0&id=1f3cf35e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3cf35e"]])

export default __exports__